import { Box, Button, Stack, Typography } from '@mui/material'
import { PreferenceTextInput } from '@/components/Settings/SettingsPreferenceSection'
import shared from '@/components/Settings/settingsShared.module.scss'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'

const profileRowStackProps = {
  direction: { xs: 'column', sm: 'row' },
  justifyContent: 'space-between',
  alignItems: { xs: 'stretch', sm: 'center' },
  className: shared.preferenceRowLayout,
}

/**
 * @param {{
 *   email: string, firstName: string, lastName: string,
 *   onFirstNameChange: (v: string) => void, onLastNameChange: (v: string) => void,
 * }} props
 */
export function GeneralSettingsProfileFields({ email, firstName, lastName, onFirstNameChange, onLastNameChange }) {
  return (
    <>
      <Stack {...profileRowStackProps}>
        <Typography component="label" className={styles.profileLabel}>Email</Typography>
        <Typography component="p" className={styles.profileEmail}>{email}</Typography>
      </Stack>
      <Stack {...profileRowStackProps}>
        <Typography component="label" className={styles.profileLabel}>First Name</Typography>
        <PreferenceTextInput aria-label="First name" value={firstName} onChange={onFirstNameChange} />
      </Stack>
      <Stack {...profileRowStackProps}>
        <Typography component="label" className={styles.profileLabel}>Last Name</Typography>
        <PreferenceTextInput aria-label="Last name" value={lastName} onChange={onLastNameChange} />
      </Stack>
      <Box className={styles.profileSaveRow}>
        <Button variant="contained" size="small" onClick={() => {}}>Save</Button>
      </Box>
    </>
  )
}
